// FIXME: Add logger
const logger = console;

export default logger;
